import React, { useState } from 'react';
import { Layers, Settings, RotateCcw, Minimize2, Lightbulb } from 'lucide-react';
import WorkspaceSuggestionsModal from './WorkspaceSuggestionsModal';
import { featureFlags } from '../config/clerk.config';
import './WorkspaceHeader.css';

function WorkspaceHeader({
  selectedWorkspace,
  onWorkspaceChange,
  isConnected,
  onClearSession,
  onCompactSession
}) {
  const [showSuggestions, setShowSuggestions] = useState(false);

  if (!selectedWorkspace) {
    return (
      <div className="current-template-header no-template">
        <div className="template-header-content">
          <div className="template-header-icon">
            <Layers size={16} />
          </div>
          <div className="template-header-info">
            <span className="template-header-title">No Workspace Selected</span>
          </div>
          <button
            className="template-change-button"
            onClick={onWorkspaceChange}
            title="Select Workspace"
          >
            <Settings size={14} />
            <span>Select Workspace</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="current-template-header">
      <div className="template-header-content">
        <div className="template-header-icon">
          <Layers size={16} />
        </div>
        <div className="template-header-info">
          <div className="template-header-title-row">
            <span className="template-header-title">
              {selectedWorkspace.workspace_name}
            </span>
          </div>
          <button
            className="template-change-link"
            onClick={onWorkspaceChange}
            title="Change Workspace"
          >
            Change
          </button>
        </div>

        {/* Suggestions Button - Centered */}
        {featureFlags.comingSoon && (
          <button
            className="header-suggestions-button"
            onClick={() => setShowSuggestions(true)}
            title="Workspace Suggestions"
          >
            <Lightbulb size={14} />
            <span>Suggestions</span>
            <span className="suggestions-notification-dot" />
          </button>
        )}

        {/* Connection Status and Session Controls */}
        <div className="header-session-controls">
          <div className={`header-connection-status ${isConnected ? 'connected' : 'disconnected'}`}>
            <div className="header-status-dot"></div>
            <span>{isConnected ? 'Connected' : 'Connecting...'}</span>
          </div>
          <button
            className="header-session-button"
            onClick={onClearSession}
            disabled={!isConnected}
            title="Clear session"
          >
            <RotateCcw size={13} />
          </button>
          <button
            className="header-session-button"
            onClick={onCompactSession}
            disabled={!isConnected}
            title="Compact session"
          >
            <Minimize2 size={13} />
          </button>
        </div>
      </div>

      {/* Workspace Suggestions Modal (coming soon) */}
      {featureFlags.comingSoon && (
        <WorkspaceSuggestionsModal
          isOpen={showSuggestions}
          onClose={() => setShowSuggestions(false)}
        />
      )}
    </div>
  );
}

export default WorkspaceHeader;
